import { IsNumber, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { AssetDto } from 'src/app/shared/dtos/asset.dto';

export class FeedItemsResponseDto {
  @IsNumber()
  item_count: number;

  @ValidateNested({ each: true })
  @Type(() => FeedItemDto)
  items: FeedItemDto[];
}

export class FeedItemDto {
  @IsString()
  title: string;

  @IsString()
  content: string;

  @ValidateNested()
  @Type(() => AssetDto)
  headline_asset: AssetDto;

  @ValidateNested()
  @Type(() => AssetDto)
  content_header_asset: AssetDto;
}
